import styled from "styled-components";

import { colors, shadows } from "shared/ui/tokens";

export const Bar = styled.div`
    position: sticky;
    bottom: 0;
    z-index: 15;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 12px 24px;
    background: ${colors.surface};
    border-top: 1px solid ${colors.borderSoft};
    box-shadow: ${shadows.sticky};
`;
